import styled from 'styled-components';
import { Link } from '@reach/router';
import {colorsV2} from "js/config/style";

export default styled.div.attrs({
  className: 'start-now'
})`
  background-color: ${colorsV2.lightGreen};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  cursor: default;
  transition: all 0.3s ease-in-out;
  color: ${colorsV2.darkBlue};
  text-decoration: none;
`;

